export default __webpack_public_path__ + "static/media/pwaDirection1.8434a3e5.png";